import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

Vue.config.productionTip = false

import moment from 'moment'
Vue.prototype.$moment = moment

import '@/common/common.css'

import utils from '@/utils/util.js'
Vue.prototype.$utils = utils

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
